import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FileStatusButton, FileStatusIconCompleted, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close } from "@air/next-icons";
import { useRouter } from "next/router";
import React, { memo, useEffect } from "react";
import { PaneItemTW } from "~/components/FileStatusTrackingPane/PaneItemTW";
import { createAllContentAssetRoute, Routes } from "~/constants/routes";
export const CopyToWorkspaceCompletedPanelItem = /*#__PURE__*/ memo((param)=>{
    let { metadata: { duplicatedRootBoards, duplicatedRootClips, targetWorkspaceId }, onClear } = param;
    var _duplicatedRootBoards_, _duplicatedRootClips_;
    const { push } = useRouter();
    const copiedBoard = !!(duplicatedRootBoards === null || duplicatedRootBoards === void 0 ? void 0 : duplicatedRootBoards.length);
    const itemId = (duplicatedRootBoards === null || duplicatedRootBoards === void 0 ? void 0 : (_duplicatedRootBoards_ = duplicatedRootBoards[0]) === null || _duplicatedRootBoards_ === void 0 ? void 0 : _duplicatedRootBoards_.id) || (duplicatedRootClips === null || duplicatedRootClips === void 0 ? void 0 : (_duplicatedRootClips_ = duplicatedRootClips[0]) === null || _duplicatedRootClips_ === void 0 ? void 0 : _duplicatedRootClips_.id);
    const workspaceUrl = itemId ? copiedBoard ? "/b/".concat(itemId) : createAllContentAssetRoute(itemId) : "".concat(Routes.media.all, "?wsid=").concat(targetWorkspaceId);
    useEffect(()=>{
        setTimeout(()=>{
            window.open(workspaceUrl, "_blank");
        }, 2000);
    }, [
        workspaceUrl
    ]);
    return /*#__PURE__*/ _jsx(PaneItemTW, {
        avatar: /*#__PURE__*/ _jsx(FileStatusIconCompleted, {}),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: "Save complete!"
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "If you weren't redirected, ",
                    /*#__PURE__*/ _jsx("button", {
                        className: "text-12 text-blue-9 hover:text-blue-11 hover:underline",
                        onClick: ()=>push(workspaceUrl),
                        children: "click here"
                    })
                ]
            })
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusButton, {
            label: "Clear",
            onClick: ()=>onClear(),
            children: /*#__PURE__*/ _jsx(Close, {
                className: "size-4"
            })
        })
    });
});
CopyToWorkspaceCompletedPanelItem.displayName = "CopyToWorkspaceCompletedPanelItem";
